import React from 'react';
import { Link } from 'react-router-dom';
import RegButton from './button';
import RegCta from './regCTA';

function Register(props) {
  const { data } = props;

  const info1 = [
    '    تاریخ شروع دوره: <b>      ۳۱ تیر ماه </b>   مدت دوره: <b>۳ ماه</b>',
    '   تعداد جلسات:<b> ۱۲ جلسه</b>',
    '    پلتفرم برگزاری:<b>Google Meet</b>',
    '     برگزار کننده و پشتیبانی: <b>تیم فیت لاینز</b>',
    'روز و ساعت جلسات:<b> سه شنبه   ها ساعت ۲۰ </b>',
  ];

  const info2 = [
    'استفاده رایگان از اپلیکیشن ورزشی فیت لاینز به مدت<b><u> ۳ ماه</u></b>',
    'عضویت در گروه تلگرامی و همراه بودن با بچه های دوره قبلی',
    'پشتیبانی کامل از طریق گروه تلگرام',
    'دسترسی <b><u>نامحدود</u></b> به فیلم جلسات در پنل شخصی',
    ' آنالیز و بررسی گزارش های فردی شرکت کنندگان توسط مدرس دوره',
  ];

  return (
    <div className=" ">
      <section className="text-center bg-main">
        <div className="px-6 py-12 md:px-12">
          <div className="container mx-auto xl:px-32">
            <div className="flex grid items-center lg:grid-cols-1">
              <div className="mb-12 md:mt-12 lg:mt-0 lg:mb-0 text-right">
                <div className="flex grid lg:grid-cols-2 rounded-lg bg-white px-6 py-12 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] backdrop-blur-[25px] dark:bg-[hsla(0,0%,5%,0.55)] dark:shadow-black/20 md:px-12 lg:-mr-14">
                  <div className="container flex mx-auto w-full font-bold items-center justify-center">
                    <ul className="flex flex-col  p-4">
                      <span className="font-bold mb-5">
                        اطلاعات دوره Shape Up{' '}
                      </span>
                      {info1.map((item) => (
                        <li className="border-gray-400 flex flex-row mb-2">
                          <div className="select-none cursor-pointer bg-gray-200 rounded-md flex flex-1 items-center p-4  transition duration-500 ease-in-out transform hover:-translate-y-1 hover:shadow-lg">
                            <div className="flex-1 pl-1">
                              <div className="font-medium">
                                <p
                                  className="text-main font-custom1"
                                  dangerouslySetInnerHTML={{
                                    __html: item,
                                  }}></p>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="container flex mx-auto w-full font-bold items-center justify-center">
                    <ul className="flex flex-col  p-4">
                      <span className="font-bold mb-5">
                        با ثبت نام در Shape Up چه امکاناتی دریافت می کنید؟
                      </span>
                      {info2.map((item) => (
                        <li className="border-gray-400 flex flex-row mb-2">
                          <div className="select-none cursor-pointer bg-gray-200 rounded-md flex flex-1 items-center p-4  transition duration-500 ease-in-out transform hover:-translate-y-1 hover:shadow-lg">
                            <div className="flex-1 pl-1">
                              <div className="font-medium">
                                <p
                                  className="text-whimainte font-custom1"
                                  dangerouslySetInnerHTML={{
                                    __html: item,
                                  }}></p>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Register;
